import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.sobre-qbd.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/sobre-qbd")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
